// Snapshot of the Sales Ops Policy Bible chain/geo table. svc-offer evaluates against its own
// copy; this one backs PolicyBibleReferenceDialog and resolves the matched rule for display.

export type PolicyBibleCampaignRule = {
  chain: string;
  dateChangeAllowedDays?: number;
  geo: string;
  numberOfDateChanges?: string;
};

export const POLICY_BIBLE_CAMPAIGN_RULES: Array<PolicyBibleCampaignRule> = [
  { chain: 'Accor', geo: 'Intl', dateChangeAllowedDays: 45, numberOfDateChanges: '1' },
  { chain: 'Accor', geo: 'Australia', dateChangeAllowedDays: 45, numberOfDateChanges: '1' },
  { chain: 'Ascott', geo: 'Australia', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  { chain: 'Ascott', geo: 'Intl', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  { chain: 'Ayana', geo: 'Intl', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  { chain: 'Clermont', geo: 'Intl', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  { chain: 'EVT', geo: 'Australia', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  { chain: 'EVT', geo: 'Intl', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  { chain: 'Grecotel', geo: 'Intl', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  { chain: 'Highgate', geo: 'Intl', dateChangeAllowedDays: 30, numberOfDateChanges: '1' },
  { chain: 'Hilton', geo: 'Intl' },
  { chain: 'Hilton', geo: 'Australia' },
  { chain: 'Hyatt', geo: 'Australia', dateChangeAllowedDays: 45, numberOfDateChanges: '1' },
  { chain: 'Hyatt', geo: 'Intl', dateChangeAllowedDays: 45, numberOfDateChanges: '1' },
  { chain: 'IHG', geo: 'Australia', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  { chain: 'IHG', geo: 'Intl', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  { chain: 'Kerzner', geo: 'Australia' },
  { chain: 'Kerzner', geo: 'Intl' },
  { chain: 'Kimpton', geo: 'Intl', dateChangeAllowedDays: 30, numberOfDateChanges: '1' },
  { chain: 'Lalit', geo: 'Intl' },
  { chain: 'Langham', geo: 'Australia', dateChangeAllowedDays: 45, numberOfDateChanges: '1' },
  { chain: 'Langham', geo: 'Intl', dateChangeAllowedDays: 45, numberOfDateChanges: '1' },
  { chain: 'Marriott', geo: 'Intl/Aus', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  { chain: 'Melia', geo: 'Intl' },
  { chain: 'Minor', geo: 'Australia' },
  { chain: 'Minor', geo: 'Intl' },
  { chain: 'Mulia', geo: 'Intl', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  { chain: 'Nomade', geo: 'Intl', dateChangeAllowedDays: 21, numberOfDateChanges: '2' },
  { chain: 'Oberoi', geo: 'Intl', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  { chain: 'Oberoi', geo: 'India', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  { chain: 'Pro Invest', geo: 'Australia', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  { chain: 'Pro Invest', geo: 'Intl', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  { chain: 'RACV', geo: 'Australia' },
  { chain: 'Shangri La', geo: 'Intl' },
  { chain: 'Shangri La', geo: 'Australia' },
  { chain: 'Standard', geo: 'Australia', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  { chain: 'Standard', geo: 'India', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  { chain: 'Standard', geo: 'International', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  { chain: 'Standard', geo: 'USA', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  { chain: 'Standard (GOLF wholesale)', geo: 'Intl', dateChangeAllowedDays: 21, numberOfDateChanges: 'Unlimited' },
  {
    chain: 'Standard (GOLF WHOLESALE)',
    geo: 'Australia',
    dateChangeAllowedDays: 21,
    numberOfDateChanges: 'Unlimited',
  },
  { chain: 'TFE', geo: 'Intl', dateChangeAllowedDays: 45, numberOfDateChanges: '1' },
  { chain: 'TFE', geo: 'Australia', dateChangeAllowedDays: 45, numberOfDateChanges: '1' },
  { chain: 'The Star', geo: 'Australia', dateChangeAllowedDays: 21, numberOfDateChanges: '1' },
  { chain: 'Two Roads', geo: 'Intl' },
  { chain: 'Vinpearl', geo: 'Intl' },
];

// Normalized LE_Hotel_Chains__c picklist value -> normalized Policy Bible chain key, for values that don't match exactly.
export const POLICY_BIBLE_CHAIN_ALIASES: Record<string, string> = {
  'standard template': 'standard',
  marriot: 'marriott',
  'clermont hotels': 'clermont',
  'golf wholesale': 'standard (golf wholesale)',
  glh: 'clermont',
};

// Normalized real geo value -> normalized Policy Bible geo bucket.
export const POLICY_BIBLE_GEO_ALIASES: Record<string, string> = {
  au: 'australia',
  aus: 'australia',
  australia: 'australia',
  intl: 'intl',
  international: 'intl',
  'intl/aus': 'intl/australia',
  'intl aus': 'intl/australia',
  'international/australia': 'intl/australia',
  'international australia': 'intl/australia',
  us: 'usa',
  usa: 'usa',
  'united states': 'usa',
  'united states of america': 'usa',
  nz: 'intl',
  'new zealand': 'intl',
};
